import React, { useState } from 'react';
import './ScannerCard.css';

function ScannerCard({ scanner, onConfigClick, onTestWebhook }) {
    const [showKeyModal, setShowKeyModal] = useState(false);
    const [copied, setCopied] = useState(false);
    const hasWebhook = scanner.config.functionalityType === 'WEBHOOK' &&
                      (scanner.config.webhook || scanner.config.webhookUrl);

    const handleCopyKey = () => {
        navigator.clipboard.writeText(scanner.scannerKey);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 3000);
    };

    return (
        <div className="scanner-card">
            <div className="scanner-card-header">
                <div className="scanner-header-content">
                    <h3>{scanner.name}</h3>
                    <span className={`status-badge ${scanner.isConnected ? 'connected' : 'disconnected'}`}>
                        {scanner.isConnected ? 'Connected' : 'Disconnected'}
                    </span>
                </div>
            </div>

            <div className="scanner-card-body">
                {/* First row: Mode and Webhook */}
                <div className="info-row-dual">
                    <div className="info-col">
                        <span className="label">Mode:</span>
                        <span className="value">{scanner.config.functionalityType}</span>
                    </div>

                    {scanner.config.functionalityType === 'WEBHOOK' && scanner.config.webhook ? (
                        <div className="info-col">
                            <span className="label">Webhook:</span>
                            <span className="value">
                                <strong>{scanner.config.webhook.name}</strong>
                                <br />
                                <span className="truncate" style={{ fontSize: '12px', color: '#666' }}>
                                    {scanner.config.webhook.webhookUrl}
                                </span>
                            </span>
                        </div>
                    ) : (
                        <div className="info-col"></div>
                    )}
                </div>

                {/* Second row: Security Policy and Show Key button */}
                <div className="info-row-dual">
                    {scanner.config.securityPolicy ? (
                        <div className="info-col">
                            <span className="label">Security Policy:</span>
                            <div className="value">
                                <strong>{scanner.config.securityPolicy.name}</strong>
                                <div className="security-metrics">
                                    <div className="metric">
                                        <span className="metric-label">Double Side</span>
                                        <span className="metric-value">{scanner.config.securityPolicy.requireDoubleSideScan ? 'YES' : 'NO'}</span>
                                    </div>
                                    <div className="metric">
                                        <span className="metric-label">Min Checks</span>
                                        <span className="metric-value">{scanner.config.securityPolicy.minimumRequiredPositiveSecurityChecksAbsolute}</span>
                                    </div>
                                    <div className="metric">
                                        <span className="metric-label">Min %</span>
                                        <span className="metric-value">{scanner.config.securityPolicy.minimumRequiredPositiveSecurityChecksRelative}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="info-col">
                            <span className="label">Security Settings:</span>
                            <div className="value">
                                <div className="security-metrics">
                                    <div className="metric">
                                        <span className="metric-label">Double Side</span>
                                        <span className="metric-value">{scanner.config.requireDoubleSideScan ? 'YES' : 'NO'}</span>
                                    </div>
                                    <div className="metric">
                                        <span className="metric-label">Min Checks</span>
                                        <span className="metric-value">{scanner.config.minimumRequiredPositiveSecurityChecksAbsolute}</span>
                                    </div>
                                    <div className="metric">
                                        <span className="metric-label">Min %</span>
                                        <span className="metric-value">{scanner.config.minimumRequiredPositiveSecurityChecksRelative}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="info-col">
                        <span className="label">Scanner Key:</span>
                        <div className="key-button-container">
                            <span className="key-icon">🔑</span>
                            <button
                                onClick={() => setShowKeyModal(true)}
                                className="show-key-btn"
                            >
                                Show Key
                            </button>
                        </div>
                    </div>
                </div>

                {scanner.associatedUsers && scanner.associatedUsers.length > 0 && (
                    <div className="info-row">
                        <span className="label">Assigned Users:</span>
                        <span className="value users-list">
                            {scanner.associatedUsers.map(u => u.name).join(', ')}
                        </span>
                    </div>
                )}
            </div>

            <div className="scanner-card-footer">
                <button
                    onClick={() => onConfigClick(scanner)}
                    className="config-btn"
                >
                    Configure
                </button>
                {hasWebhook && (
                    <div className="test-webhook-buttons">
                        <button
                            onClick={() => onTestWebhook(scanner.id, 'ok')}
                            className="test-btn test-ok"
                            title="Send test webhook with successful validation"
                        >
                            Test OK
                        </button>
                        <button
                            onClick={() => onTestWebhook(scanner.id, 'nok')}
                            className="test-btn test-nok"
                            title="Send test webhook with failed validation"
                        >
                            Test NOK
                        </button>
                    </div>
                )}
            </div>

            {/* Key Modal */}
            {showKeyModal && (
                <div className="key-modal-overlay" onClick={() => setShowKeyModal(false)}>
                    <div className="key-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="key-modal-header">
                            <h4>Scanner Key</h4>
                            <button className="key-modal-close" onClick={() => setShowKeyModal(false)}>×</button>
                        </div>
                        <div className="key-modal-body">
                            <div className="key-display">
                                <code>{scanner.scannerKey}</code>
                            </div>
                            <button
                                className={`copy-key-btn ${copied ? 'copied' : ''}`}
                                onClick={handleCopyKey}
                            >
                                {copied ? '✅ Copied to Clipboard!' : '📋 Copy to Clipboard'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ScannerCard;
